import {
  ControlGroup,
  type ControlGroupCaptionProps,
  type ControlGroupLabelProps,
  type ControlGroupProps,
  type ControlGroupValidationProps,
} from '../ControlGroup'

export type RadioGroupProps = ControlGroupProps
export type RadioGroupLabelProps = ControlGroupLabelProps
export type RadioGroupCaptionProps = ControlGroupCaptionProps
export type RadioGroupValidationProps = ControlGroupValidationProps

export const RadioGroup = ControlGroup
